// src/stores/authStore.js
import { defineStore } from "pinia";
import { getAuth, signInWithPopup, signOut, GoogleAuthProvider, OAuthProvider, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Firestore functions
import { db } from "@/firebaseConfig"; // Firestore instance

const auth = getAuth();
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    username: "Guest",
    admin: false, // 🔥 Now fetched from Firestore
    active: false, // 🔥 Now fetched from Firestore
    loading: true, // Tracks if auth state is still initializing
  }),

  actions: {
    async login() {
      try {
        const result = await signInWithPopup(auth, googleProvider);
        await this.setUser(result.user);
      } catch (error) {
        console.error("Login error:", error);
      }
    },

    async loginWithMicrosoft() {
      try {
        const result = await signInWithPopup(auth, microsoftProvider);
        await this.setUser(result.user);
      } catch (error) {
        console.error("Login error:", error);
      }
    },

    async logout() {
      await signOut(auth);
      this.user = null;
      this.username = "Guest";
      this.admin = false;
      this.active = false;
    },

    async setUser(user) {
      if (user) {
        // Set base user data from Firebase Auth
        this.user = {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
        };

        // 🔥 Fetch user details from Firestore
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          this.username = userData.username || "Guest";
          this.admin = userData.admin === true; // 🔥 Get admin status from Firestore
          this.active = userData.active === true; // 🔥 Get active status from Firestore
        } else {
          this.username = "Guest";
          this.admin = false;
          this.active = false;
        }
      } else {
        this.user = null;
        this.username = "Guest";
        this.admin = false;
        this.active = false;
      }
    },

    initializeAuth() {
      this.loading = true;
      onAuthStateChanged(auth, async (user) => {
        await this.setUser(user);
        this.loading = false;
      });
    },
  },
});
